import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  /* Enhanced glassmorphism for footer */
  background: rgba(40, 40, 40, 0.25);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-top: 1px solid rgba(235, 219, 178, 0.1);
  padding: var(--spacing-md);
  margin-top: var(--spacing-xl);
  position: relative;

  @media (max-width: 768px) {
    padding: var(--spacing-sm);
    margin-top: var(--spacing-lg);
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Roboto', sans-serif;
`;

const FooterText = styled.p`
  color: var(--text-muted);
  font-size: 0.75rem;
  margin: 0;
  letter-spacing: 0.4px;
  opacity: 0.7;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 0.7rem;
  }
  
  span {
    color: var(--primary);
    font-weight: 500;
  }
`;



const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterText>
          &copy; {new Date().getFullYear()} <span>Jeff Trevorrow</span> | Solutions Architect | All rights reserved
        </FooterText>
      </FooterContent>
    </FooterContainer>
  );
};

// Use React.memo to prevent unnecessary re-renders
export default React.memo(Footer);
